




















import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { secondsToText } from "../utils";
// import { watch } from 'fs';

@Component
export default class Player extends Vue {
  @Prop({ default: false }) private isTranscriptPlayer!: boolean;
  @Prop() private url?: string;
  @Prop() private label?: string;
  @Prop() private emitPlaybackLocation?: boolean;
  @Prop() private playsegment?: number[];
  public video?: HTMLVideoElement;
  private audio?: HTMLAudioElement;
  private progressPercent: number = 0;
  private progress: string = "0:00";
  private duration: string = "";

  public pause() {
    this.audio!.pause();
    this.$emit("onPause");
  }

  private created() {
    this.setupAudio();
  }

  @Watch("video")
  private test() {
    console.log(this.video);
  }

  private setupAudio() {
    this.audio = new Audio(this.url);
    const audio = this.audio!;

    audio.onloadeddata = () => {
      this.duration = secondsToText(audio.duration);
    };

    audio.ontimeupdate = () => {
      this.progressPercent = (audio.currentTime * 100.0) / audio.duration;
      this.progress = secondsToText(audio.currentTime);
      if (this.emitPlaybackLocation) {
        console.log("Emiting current playback location");
        this.$emit("currentAudioLocation", audio.currentTime);
      }
    };

    audio.onplaying = () => {
      this.$emit("playing");
    };
  }

  private beforeDestroy() {
    this.pause();
  }

  private handleBarClick(e: MouseEvent) {
    if (this.audio) {
      let playbackBar: HTMLElement = this.$refs.playbackBar as HTMLElement;
      let perc = e.offsetX / playbackBar.offsetWidth;
      let currentTime = perc * this.audio.duration;
      this.audio.currentTime = currentTime;
      if (this.video) {
        this.video.currentTime = currentTime;
      }
    }
  }

  private play() {
    if (this.audio!.paused) {
      this.audio!.play();
      if (this.video) {
        this.video.play();
        console.log("play video");
      }
      this.$emit("onPlay");
    } else {
      this.pause();
      if (this.video) {
        this.video.pause();
      }
    }
  }

  @Watch("playsegment")
  private playSegment() {
    console.log("change");
    if (!this.playsegment || this.playsegment!.length < 1) {
      return;
    }
    const start = this.playsegment![0];
    const end = this.playsegment![1];
    this.audio!.currentTime = start;
    this.audio!.play();
    if (this.video) {
      this.video.currentTime = start;
      this.video.play();
    }
    // let ad = this.audio;
    let int = setInterval((ctx: Player) => {
      if (this.audio!.currentTime > end) {
        this.audio!.pause();
        if (this.video) {
          this.video.pause();
        }
        clearInterval(int);
      }
    }, 100);
    // this.playsegment = [];
  }
  @Watch("url")
  private onUrlChanged() {
    this.pause();
    this.progressPercent = 0;
    this.progress = "0:00";
    this.setupAudio();
  }
}
